import { useState } from 'react';

import CustomDiscount from './BookingEndineDiscountSettingsCustomDiscount';
import { Switch } from "antd";
import PriceSource from './BookingEngineDiscountSettingsPriceSource';
import DayWiseDiscount from './BookingEngineDiscountSettingsDayWise';
import AvailabilitySource from './BookingEngineDiscountSettingsAvailabilitySource';
const DiscountSettings = ({
    localHotelDetailsState,
    setLocalHotelDetailsState }) => {

    const [pa,setPa] = useState(localHotelDetailsState?.priceAdjustment || {});



    return (
        <div className="mb-[10rem]">
            <header className="w-[100%] flex justify-between items-center">
                <div className="font-body font-[500] text-[24px] leading-[30.34px] text-fg ">
                    Price Settings
                </div>
            </header>

            {/* Additional components and logic for managing discounts can be added here */}
            <CustomDiscount
                localHotelDetailsState={localHotelDetailsState}
                setLocalHotelDetailsState={setLocalHotelDetailsState}
                pa={pa}
                setPa={setPa}
            />
            <PriceSource
                localHotelDetailsState={localHotelDetailsState}
                setLocalHotelDetailsState={setLocalHotelDetailsState}
                pa={pa}
                setPa={setPa}
            />
            <AvailabilitySource
            localHotelDetailsState={localHotelDetailsState}
            setLocalHotelDetailsState={setLocalHotelDetailsState}
            pa={pa}
            setPa={setPa}
            />
            <DayWiseDiscount
                pa={pa}
                localHotelDetailsState={localHotelDetailsState}
                setLocalHotelDetailsState={setLocalHotelDetailsState}
                setPa={setPa}
            />

        </div>
    );
}

export default DiscountSettings;